export default {
  sales_consultants: [],
  sales_consultant: null,
};
